import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})

export class RouterManagerService {

  private permissionAuthority: boolean = true;

  constructor(private router: Router, private storageService: StorageService) {
    
  }

  public isAuthorized(): boolean {
    return this.storageService.getAccessToken() != null;
  }

  public arePermissionsAuthorized() {
    return this.permissionAuthority;
  }

  public restrictDoubleLoginAuthorizedUser() {
    if (this.isAuthorized()) {
      this.router.navigateByUrl("/joytogive");
    }
  }

  public restrictThroughPermissions(permissions: string[], operation: string): void {

    var USER_PERMISSIONS = this.storageService.getPermissions();
    //console.log('User Permissions:' + JSON.stringify(USER_PERMISSIONS));
    
    if (permissions == null || USER_PERMISSIONS == null) {
      this.permissionAuthority = false;
      return;
    }

    switch (operation) {
      case 'allowAny':
        this.permissionAuthority = false;
        //console.log('User Permissions: ' + JSON.stringify(USER_PERMISSIONS)) 
        //console.log('permissions: ' + JSON.stringify(permissions)) 
        for (var i = 0; i < USER_PERMISSIONS.length; i++) {
          if (this.hasPermission(permissions, USER_PERMISSIONS[i])) {
            this.permissionAuthority = true;
            console.log('has permission: ' + this.permissionAuthority);
            break;
          }
        }
        break;

      case 'allowByGroup':
        this.permissionAuthority = true;
        for (var i = 0; i < permissions.length; i++) {
          if (!this.hasPermission(USER_PERMISSIONS, permissions[i])) {
            this.permissionAuthority = false;
            break;
          }
        }
        break;
    }
  }

  private hasPermission(locks: string[], key: string): boolean {
    return locks.indexOf(key) == -1 ? false : true;
  }

}
